import { Fragment } from "react";
import "./App.css";
import Home from "./pages/Home";

function App() {
  return (
    <Fragment>
      <Home />
    </Fragment>
  );
}

export default App;
